"use strict";
exports.__esModule = true;
exports.CutoffType = exports.ResponseChoice = exports.BillPayOverwriteType = exports.EmbedPayNowEligibilityFailureCode = exports.BillStage = exports.BillActionStatus = exports.ServiceIssueCode = exports.RentPaymentStatus = exports.CreditLineProductType = exports.BillerType = exports.BillType = void 0;
var BillType;
(function (BillType) {
    BillType["EPISODIC"] = "EPISODIC";
})(BillType = exports.BillType || (exports.BillType = {}));
var BillerType;
(function (BillerType) {
    BillerType["OUT_OF_NETWORK"] = "OUT_OF_NETWORK";
    BillerType["DIRECT_INTEGRATION"] = "DIRECT_INTEGRATION";
    BillerType["PORTAL"] = "PORTAL";
    BillerType["FLEX_ANYWHERE"] = "FLEX_ANYWHERE";
    BillerType["INVALID_BILLER_TYPE"] = "INVALID_BILLER_TYPE";
})(BillerType = exports.BillerType || (exports.BillerType = {}));
var CreditLineProductType;
(function (CreditLineProductType) {
    CreditLineProductType["SLC"] = "SLC";
    CreditLineProductType["FSLC"] = "FSLC";
})(CreditLineProductType = exports.CreditLineProductType || (exports.CreditLineProductType = {}));
var RentPaymentStatus;
(function (RentPaymentStatus) {
    RentPaymentStatus["ON_TRACK"] = "ON_TRACK";
    RentPaymentStatus["SERVICE_ISSUE"] = "SERVICE_ISSUE";
    RentPaymentStatus["PROCESSING"] = "PROCESSING";
    RentPaymentStatus["RENT_PAID"] = "RENT_PAID";
    RentPaymentStatus["NOT_PAID"] = "NOT_PAID";
})(RentPaymentStatus = exports.RentPaymentStatus || (exports.RentPaymentStatus = {}));
var ServiceIssueCode;
(function (ServiceIssueCode) {
    ServiceIssueCode["ISSUE_MESSAGING"] = "ISSUE_MESSAGING";
    ServiceIssueCode["BALANCE_TOO_HIGH"] = "BALANCE_TOO_HIGH";
    ServiceIssueCode["BALANCE_TOO_LOW"] = "BALANCE_TOO_LOW";
    ServiceIssueCode["ZERO_BALANCE"] = "ZERO_BALANCE";
    ServiceIssueCode["RETRY_OR_UPDATE_CARD"] = "RETRY_OR_UPDATE_CARD";
    ServiceIssueCode["UPDATE_DEBIT_CARD"] = "UPDATE_DEBIT_CARD";
    ServiceIssueCode["RELINK_PROPERTY"] = "RELINK_PROPERTY";
    ServiceIssueCode["SELF_PAY_DDA"] = "SELF_PAY_DDA";
    ServiceIssueCode["SELF_PAY_DDA_ISSUED"] = "SELF_PAY_DDA_ISSUED";
    ServiceIssueCode["SELF_PAY_VC"] = "SELF_PAY_VC";
    ServiceIssueCode["SELF_PAY_VC_ISSUED"] = "SELF_PAY_VC_ISSUED";
    ServiceIssueCode["SELF_PAY_PENDING"] = "SELF_PAY_PENDING";
    ServiceIssueCode["SELF_PAY_DDA_PENDING_BP_WINDOW_OPEN"] = "SELF_PAY_DDA_PENDING_BP_WINDOW_OPEN";
    ServiceIssueCode["SELF_PAY_VC_PENDING_BP_WINDOW_OPEN"] = "SELF_PAY_VC_PENDING_BP_WINDOW_OPEN";
    ServiceIssueCode["YARDI_ZERO_BALANCE"] = "YARDI_ZERO_BALANCE";
    ServiceIssueCode["PAST_DUE_RENT"] = "PAST_DUE_RENT";
    ServiceIssueCode["SELF_PAY_OPTED_OUT"] = "SELF_PAY_OPTED_OUT";
    ServiceIssueCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    ServiceIssueCode["GENERIC_PAYMENT_FAILURE"] = "GENERIC_PAYMENT_FAILURE";
    ServiceIssueCode["DEFAULT_PAYMENT_FAILURE"] = "DEFAULT_PAYMENT_FAILURE";
    ServiceIssueCode["PAST_DOWNPAYMENT_DEADLINE"] = "PAST_DOWNPAYMENT_DEADLINE";
    ServiceIssueCode["NO_ISSUE"] = "NO_ISSUE";
    ServiceIssueCode["ADDITIONAL_DEPOSIT_NEEDED"] = "ADDITIONAL_DEPOSIT_NEEDED";
    ServiceIssueCode["PORTAL_VALIDATE_CREDENTIALS_FAILURE"] = "PORTAL_VALIDATE_CREDENTIALS_FAILURE";
    ServiceIssueCode["NO_ACTIVE_LEASE"] = "BILLING_NO_ACTIVE_LEASE";
    ServiceIssueCode["INACTIVE_PORTAL"] = "BILLING_INACTIVE_PORTAL";
    ServiceIssueCode["MULTIPLE_ACTIVE_LEASES"] = "BILLING_MULTIPLE_ACTIVE_LEASES";
    ServiceIssueCode["VALID_CREDENTIALS_BUT_2FA_BLOCKED"] = "BILLING_VALID_CREDENTIALS_BUT_2FA_BLOCKED";
    ServiceIssueCode["PORTAL_RESET_PASSWORD_REQUIRED"] = "BILLING_RESET_PASSWORD_REQUIRED";
    ServiceIssueCode["BILLING_API_EXCEPTION"] = "BILLING_API_EXCEPTION";
    ServiceIssueCode["PORTAL_URL_UPDATE_REQUIRED"] = "BILLING_PORTAL_URL_UPDATE_REQUIRED";
    ServiceIssueCode["EARLY_PAY_PAYMENT_REQUIRED"] = "EARLY_PAY_PAYMENT_REQUIRED";
    ServiceIssueCode["FA_SETTLEMENT_PENDING"] = "FA_SETTLEMENT_PENDING";
})(ServiceIssueCode = exports.ServiceIssueCode || (exports.ServiceIssueCode = {}));
var BillActionStatus;
(function (BillActionStatus) {
    BillActionStatus["PAY_RENT"] = "PAY_RENT";
    BillActionStatus["FUND_EARLY"] = "FUND_EARLY";
    BillActionStatus["PAY_EARLY"] = "PAY_EARLY";
    BillActionStatus["VIEW_DETAILS"] = "VIEW_DETAILS";
})(BillActionStatus = exports.BillActionStatus || (exports.BillActionStatus = {}));
var BillStage;
(function (BillStage) {
    BillStage["GET_READY"] = "GET_READY";
    BillStage["FIRST_PAYMENT"] = "FIRST_PAYMENT";
    BillStage["RENT_PAYMENT"] = "RENT_PAYMENT";
    BillStage["SECOND_PAYMENT"] = "SECOND_PAYMENT";
})(BillStage = exports.BillStage || (exports.BillStage = {}));
var EmbedPayNowEligibilityFailureCode;
(function (EmbedPayNowEligibilityFailureCode) {
    EmbedPayNowEligibilityFailureCode["BP_WINDOW"] = "BP_WINDOW";
    EmbedPayNowEligibilityFailureCode["AUTOPAY_ON"] = "AUTOPAY_ON";
    EmbedPayNowEligibilityFailureCode["RENT_PAYMENT_IN_PROGRESS"] = "RENT_PAYMENT_IN_PROGRESS";
    EmbedPayNowEligibilityFailureCode["RENT_PAID"] = "RENT_PAID";
    EmbedPayNowEligibilityFailureCode["RELINK_PROPERTY"] = "RELINK_PROPERTY";
    EmbedPayNowEligibilityFailureCode["INVALID_PRODUCT"] = "INVALID_PRODUCT";
    EmbedPayNowEligibilityFailureCode["INVALID_BALANCE"] = "INVALID_BALANCE";
    EmbedPayNowEligibilityFailureCode["UNKNOWN"] = "UNKNOWN";
    EmbedPayNowEligibilityFailureCode["SIGNUP"] = "SIGNUP";
    EmbedPayNowEligibilityFailureCode["COMPLETE_SIGNUP"] = "COMPLETE_SIGNUP";
    EmbedPayNowEligibilityFailureCode["CREDIT_LINE_SUSPENDED"] = "CREDIT_LINE_SUSPENDED";
    EmbedPayNowEligibilityFailureCode["CREDIT_LINE_DECLINED"] = "CREDIT_LINE_DECLINED";
    EmbedPayNowEligibilityFailureCode["BALANCE_TOO_HIGH"] = "BALANCE_TOO_HIGH";
    EmbedPayNowEligibilityFailureCode["BALANCE_TOO_LOW"] = "BALANCE_TOO_LOW";
    EmbedPayNowEligibilityFailureCode["NOT_COVERED"] = "NOT_COVERED";
})(EmbedPayNowEligibilityFailureCode = exports.EmbedPayNowEligibilityFailureCode || (exports.EmbedPayNowEligibilityFailureCode = {}));
var BillPayOverwriteType;
(function (BillPayOverwriteType) {
    BillPayOverwriteType["CAN_OVERWRITE_HIGHER"] = "canOverwriteHigher";
    BillPayOverwriteType["CAN_OVERWRITE_LOWER"] = "canOverwriteLower";
    BillPayOverwriteType["CANNOT_OVERWRITE"] = "cannotOverwrite";
    BillPayOverwriteType["CANNOT_OVERWRITE_ZERO_BALANCE"] = "cannotOverwrite";
    BillPayOverwriteType["CAN_OVERWRITE_ZERO_BALANCE"] = "canOverwriteZeroBalanve";
    BillPayOverwriteType["CAN_OVERWRITE_PAST_DUE"] = "canOverwritePastDue";
})(BillPayOverwriteType = exports.BillPayOverwriteType || (exports.BillPayOverwriteType = {}));
var ResponseChoice;
(function (ResponseChoice) {
    ResponseChoice["INCORRECT_ESTIMATE"] = "INCORRECT_ESTIMATE";
    ResponseChoice["ADDITIONAL_CHARGES"] = "ADDITIONAL_CHARGES";
    ResponseChoice["ROOMMATE_PORTION"] = "ROOMMATE_PORTION";
    ResponseChoice["BEHIND_ON_RENT"] = "BEHIND_ON_RENT";
    ResponseChoice["PERMANENT_INCREASE"] = "PERMANENT_INCREASE";
    ResponseChoice["ALREADY_PAID"] = "ALREADY_PAID";
    ResponseChoice["BALANCE_TOO_LOW"] = "BALANCE_TOO_LOW";
})(ResponseChoice = exports.ResponseChoice || (exports.ResponseChoice = {}));
var CutoffType;
(function (CutoffType) {
    CutoffType["EARLY_PAY_DP_CUTOFF"] = "EARLY_PAY_DP_CUTOFF";
    CutoffType["ADDITIONAL_DP_CUTOFF"] = "ADDITIONAL_DP_CUTOFF";
})(CutoffType = exports.CutoffType || (exports.CutoffType = {}));
